<template><section>
<div class="page">
  <div>
    <h2>
      Problem seeing contacts</h2>
    <p>
      In order to get the best experience from ToTok, we strongly recommend you allow ToTok access to your phone's
      contacts. Here are a few things to know about using ToTok with your phone's contacts.
    </p>
    <h3>How to enable access to your contacts</h3>
    <p>If you initially denied ToTok access to your phone's contacts, you can enable access by going to your phone's
      settings:
    </p>
    <ol>
      <li>Go to <strong>Settings > Security</strong>.</li>
      <li>
        Tap <strong>Contacts</strong>.
      </li>
      <li>
        Make sure ToTok is turned on.
      </li>
    </ol>
    <h3>If ToTok is grayed out or doesn't appear in privacy settings</h3>
    <p>
      This is a rare issue, but it does happen to a small number of users. Ensure you don't have any restrictions set in
      phone <strong>Settings > General > Restrictions</strong>. Otherwise, you'll most likely need to restore your phone.
    </p>
  </div>
</div>
 </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
